<mat-card>
  <mat-card-header>
    <mat-card-title>Education Details</mat-card-title>
  </mat-card-header>

  <mat-card-content class="m-t-1">
   
     

        <app-radio-input 
                [label]="'Do ' + (applicantText.you | lowercase) + ' have any qualifications?'"
                [control]="educationForm.controls.hasQualifications" shortLabel="Qualifications"
                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]"
                [submitAttempted]="submitAttempted">
          </app-radio-input>


      @if (model.education!.hasQualifications === 'true') {
        <div class="section-label">
          <mat-label>List all qualifications</mat-label>
        </div>

        @if (model.education!.qualifications.length > 0) {
          @if(!(isMobile$ | async)) {
          <table mat-table [dataSource]="model.education!.qualifications" class="mat-elevation-z1">
            <ng-container matColumnDef="qualification">
              <th mat-header-cell *matHeaderCellDef>Qualification</th>
              <td mat-cell *matCellDef="let element">{{element.type?.value}}</td>
            </ng-container>

            <ng-container matColumnDef="course">
              <th mat-header-cell *matHeaderCellDef>Course</th>
              <td mat-cell *matCellDef="let element">{{element.course}}</td>
            </ng-container>

            <ng-container matColumnDef="institution">
              <th mat-header-cell *matHeaderCellDef>Institution</th>
              <td mat-cell *matCellDef="let element">{{element.institution}}</td>
            </ng-container>

            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef>Country</th>
              <td mat-cell *matCellDef="let element">{{element.country?.Value}}</td>
            </ng-container>

            <ng-container matColumnDef="edit">
              <th mat-header-cell *matHeaderCellDef>Edit</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button (click)="edit(i)">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef>Delete</th>
              <td mat-cell *matCellDef="let element; let i = index">
                <button mat-icon-button color="warn" (click)="remove(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        }
        @if(isMobile$ | async) {
      <div class="mobile-cards">
        @for(qualification of model.education!.qualifications; track qualification; let i = $index) {
        <mat-card  class="mobile-card">
          <mat-card-content>
            <div class="mobile-card-details">
              <div class="mobile-card-item">
                <span class="label">Type:</span>
                <span class="value">{{qualification.type?.value}}</span>
              </div>
              <div class="mobile-card-item">
                <span class="label">Course:</span>
                <span class="value">{{qualification.course}}</span>
              </div>
              @if(qualification.institution) {
              <div class="mobile-card-item">
                <span class="label">Institution:</span>
                <span class="value">{{qualification.institution}}</span>
              </div>
            }
            @if(qualification.country) {
              <div class="mobile-card-item">
                <span class="label">Country:</span>
                <span class="value">{{qualification.country.Value}}</span>
              </div>
            }
            </div>
            <div class="mobile-card-actions">
              <button mat-stroked-button (click)="edit(i)" class="action-button">
                <mat-icon>edit</mat-icon>
                Edit
              </button>
              <button mat-stroked-button color="warn" (click)="remove(i)" class="action-button">
                <mat-icon>delete</mat-icon>
                Delete
              </button>
            </div>
          </mat-card-content>
        </mat-card>
  
      }
    </div>

        }
      }
        <button mat-raised-button color="primary" (click)="add()">Add a Qualification</button>
      }
        <app-radio-input 
                [label]="'Have ' + (applicantText.you | lowercase) + ' ever completed an english competency test?'" 
                [control]="educationForm.controls.completedEnglishTest"  shortLabel="Completed English Test"
                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
          </app-radio-input>

      @if (model.education!.completedEnglishTest === 'true') {
          <app-select-input
            [label]="'Which english competency test have ' + (applicantText.you | lowercase) + ' taken?'"
            [control]="educationForm.controls.englishTestTaken" shortLabel="English Test Taken"
            [options]="englishTestTakenOptions"
            [useStringValue]="true" placeholder="Select an English Competency Test">           
          </app-select-input>

          <app-date-input
            [label]="'What date did ' + (applicantText.you | lowercase) + ' take the English Competency test?'" shortLabel="English Test Date"
            [control]="educationForm.controls.englishTestDate">
          </app-date-input>

          <app-text-input
            label="Average/Overall score" 
            [control]="educationForm.controls.englishAverageScore">
          </app-text-input>

          <app-text-input
            label="Reading score"
            [control]="educationForm.controls.englishReadingScore">
          </app-text-input>
          <app-text-input
            label="Writing score" 
            [control]="educationForm.controls.englishWritingScore">
          </app-text-input>
          <app-text-input
            label="Speaking score" 
            [control]="educationForm.controls.englishSpeakingScore">
          </app-text-input>
          <app-text-input
            label="Listening score" 
            [control]="educationForm.controls.englishListeningScore">
          </app-text-input>
      }

      @if (showSkillsSection) {
        @if (showLanguageSection) {
          <app-radio-input 
                  [label]="'Are ' + (applicantText.you | lowercase) + ' accredited at the para-professional level or above by the National Accreditation Authority for Translators and Interpreters (NAATI) as either a translator or interpreter of a community language?'" 
                  [control]="educationForm.controls.isTranslator"  shortLabel="Transalator"
                  [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
            </app-radio-input>
                 

          @if (model.education!.isTranslator === 'true') {
            <app-text-input
              [label]="'For which language are ' + (applicantText.you | lowercase) + ' accredited?'"
              [control]="educationForm.controls.translatorLanguage" shortLabel="Translator Language">
            </app-text-input>
          }
        }

        <app-radio-input 
                [label]="'Do ' + (applicantText.you | lowercase) + ' have a Skills Assessment from an Australian Skills Assessing Authority?'"
                [control]="educationForm.controls.skillsAssessment" shortLabel="Skills Assessment"
                [options]="[{value: 'true', label: 'Yes'}, {value: 'false', label: 'No'}]">
          </app-radio-input>
               

        @if (model.education!.skillsAssessment === 'true') { 
          <app-text-input
            label="Name of the Assessing Authority"
            [control]="educationForm.controls.assessingAuthority" shortLabel="Assessing Authority">
          </app-text-input>

          <app-text-input
            label="Assessed Occupation" 
            [control]="educationForm.controls.assessedOccupation" shortLabel="Assessed Occupation">
          </app-text-input>
          <app-date-input
            label="Date of the Skills Assessment" 
            [control]="educationForm.controls.assessmentDate" shortLabel="Assessment Date">
          </app-date-input>
        }

      }

  </mat-card-content>
</mat-card>